// extracted by mini-css-extract-plugin
export var challenge = "Card-module--challenge--bZs4v";
export var date = "Card-module--date--z+uuE";
export var description = "Card-module--description--9enGG";
export var icon = "Card-module--icon--Viovy";
export var image = "Card-module--image--ygppW";
export var left = "Card-module--left--bUver";
export var picture = "Card-module--picture--w7hER";
export var right = "Card-module--right--YfKDQ";
export var root = "Card-module--root--VTdPX";
export var thumb = "Card-module--thumb--h64Gq";
export var title = "Card-module--title---BGlA";
export var titleContainer = "Card-module--titleContainer--Z7utZ";